import api from '../token';

export const ListClienteInativo = async () => {
  try {
    const response = await api.post('/getClienteInativo');
    return response.data;
  } catch (error) {
    
    return [];
  }
};

